import React, { useEffect, useState } from 'react'
import { ScrollView } from 'react-native'
// import { useDispatch, useSelector } from 'react-redux'
import { RouteProp } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { useDispatch } from 'react-redux'

// import styles from './styles'
import ActionCreators from '../../store/actions'
import { HGView } from '../../components/HGUI'
import NewsArticle from './NewsArticle'
import { RootStackParamList } from '../../navigators/AppNavigator'
import { NewsItemType } from '../../config/types'

type Props = {
  route: RouteProp<RootStackParamList, 'NewsDetail'>
  navigation: StackNavigationProp<RootStackParamList, 'NewsDetail'>
}

const NewsDetailScreen = (props: Props) => {
  const { route, navigation } = props
  const { newsId } = route.params
  const [loading, setLoading] = useState(false)
  const [newsArticle, setNewsArticle] = useState<NewsItemType>(null)
  const dispatch = useDispatch()
  // const { articles } = useSelector((state) => state.news)

  const loadNewsDetail = () => {
    setLoading(true)

    dispatch(ActionCreators.loadNewsDetail({ newsId }))
      .then((result) => {
        navigation.setOptions({ title: result.title })
        setNewsArticle(result)
      })
      .catch()
      .then(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    loadNewsDetail()

    if (!navigation.canGoBack()) {
      navigation.reset({
        index: 1,
        routes: [
          { name: 'News' },
          {
            name: 'NewsDetail',
            params: {
              newsId,
            },
          },
        ],
      })
    }
  }, [])

  return (
    <HGView>
      <ScrollView>
        {newsArticle && (
          <NewsArticle
            newsArticle={newsArticle}
            // isLoading={loading}
            // noContent={noContent}
          />
        )}
      </ScrollView>
    </HGView>
  )
}

export default NewsDetailScreen
